interface Props {
    month: number
    selectMonth(month: number): void
}

const months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((month) => {
    const d = new Date(2000, month, 1)
    return d.toLocaleDateString(undefined, { month: "long" })
})

/** @internal */
export function MonthSelector({ month, selectMonth }: Props) {

    return <div className="month">
        {/* TODO: this should be replaced by a button */}
        <i
            className="fa fa-chevron-left"
            onClick={() =>
                selectMonth(month - 1)
            }
        ></i>
        &nbsp;&nbsp;
        <select
            className="form-control"
            value={month}
            onChange={(e) =>
                selectMonth(
                    Number(e.target.value)
                )
            }
        >
            {months.map((m, index) => (
                <option
                    key={index + 1}
                    value={index + 1}
                >
                    {m}
                </option>
            ))}
        </select>
        &nbsp;&nbsp;
        {/* TODO: this should be replaced by a button */}
        <i
            className="fa fa-chevron-right"
            onClick={() =>
                selectMonth(month + 1)
            }
        ></i>
    </div>


}
